module.exports = "<p>\r\n  loandistribution works!\r\n</p>\r\n"